<template>
    <div class="chart-container">
        <canvas ref="chart" width="6" height="1"></canvas>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true,
        },
        data: {
            type: [Object, Array],
            required: true,
        },
        options: {
            type: [Object, Array],
            default: () => ({
                responsive: true,
                maintainAspectRatio: true,
            }),
            required: false,
        },
    },
    data: () => ({
        chart: null,
    }),
    mounted() {
        this.chart = new window.Chart(this.$refs.chart, {
            type: this.type,
            data: this.data,
            options: _.merge({}, this.options),
        });
    },
};
</script>
